import HTTP from "@/_helpers/http";
import { SERVERCONFIG__API } from "@/_helpers/urls";
import { SERVERCONFIG__MUTATIONS } from "../mutation-types";
import { SERVERCONFIG__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  s_config: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [SERVERCONFIG__MUTATIONS.SERVERCONFIG](state, data) {
    state.s_config = data;
  },
};
// Actions
const actions = {
  async [SERVERCONFIG__ACTIONS.SERVERCONFIG]({ commit, state }) {
    try {
      const url = `${SERVERCONFIG__API.SERVERCONFIG}`;
      const response = await HTTP().get(url);
      commit(SERVERCONFIG__MUTATIONS.SERVERCONFIG, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [SERVERCONFIG__ACTIONS.UPDATESERVERCONFIG]({ dispatch }, parameter) {
    try {
      const params = {
        server: parameter?.server,
        login: parameter?.login,
        password: parameter?.password,
        demo_server: parameter?.demo_server,
        demo_login: parameter?.demo_login,
        demo_password: parameter?.demo_password,
        server_name: parameter?.server_name,
        demo_server_name: parameter?.demo_server_name,
        windows_download_link: parameter?.windows_download_link,
        android_download_link: parameter?.android_download_link,
        ios_download_link: parameter?.ios_download_link,
      };

      const parameterString = Object.keys(params)
        .map(key => params[key] != null ? `${key}=${params[key]}` : "")
        .filter(param => param !== "")
        .join("&");

      const response = await HTTP().patch(
        SERVERCONFIG__API.UPDATESERVERCONFIG +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        toast.success("Successfully Updated");
        await dispatch(SERVERCONFIG__ACTIONS.SERVERCONFIG);
      }
    } catch (error) {
      console.error("Error updating server config:", error);
    }
  }

};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
